import Link from "@/03-presenters/widgets/LinkWithCountryCode";
import { cx } from "class-variance-authority";
import { openTitleStore } from "./Navigation";
import { LightVideoCreationIcon, CreativityIcon, LightCreativityIcon, CreationIcon, LightCreationIcon, MineIcon, LightMineIcon, CreativityDashboardIcon, LightCreativityDashboardIcon } from "./NavigationIcon";
const creativityWorkshopList = [{
  icon: <CreativityIcon />,
  lightIcon: <LightCreativityIcon />,
  title: "找创意",
  subItems: [{
    title: "自然流素材",
    href: "/aiToolV2/videoLibrary"
  }, {
    title: "广告素材",
    href: "/aiToolV2/adLibrary"
  }, {
    title: "内容解构",
    href: "/aiToolV2/videoAnalysis"
  }, {
    title: "卖点可视化",
    href: "/aiToolV2/inspiration"
  }, {
    title: "分镜创意",
    href: "/aiToolV2/videoClip/search"
  }],
  href: "aiToolV2/creativity"
}, {
  icon: <CreationIcon />,
  lightIcon: <LightCreationIcon />,
  title: "AI 创作",
  subItems: [{
    title: "带货脚本生成",
    href: "/aiToolV2/product"
  }, {
    title: "脚本智能仿写",
    href: "/aiToolV2/video"
  }, {
    title: "智能成片",
    href: "/aiToolV2/videoCreation"
  }],
  href: "/aiToolV2/creation"
}, {
  icon: <MineIcon />,
  lightIcon: <LightMineIcon />,
  title: "我的",
  subItems: [{
    title: "我的素材",
    href: "/aiToolV2/mine/material"
  }, {
    title: "我的创作",
    href: "/aiToolV2/mine/creation"
  }, {
    title: "我的收藏",
    href: "/aiToolV2/mine/collection"
  }],
  href: "/aiToolV2/mine/collection"
}];
const CommonItem = ({
  href,
  icon,
  title,
  subItems,
  isDashBoard,
  isHomePage,
  lightIcon
}: {
  href: string;
  icon: React.ReactNode;
  lightIcon: React.ReactNode;
  title: string;
  subItems: {
    href: string;
    icon?: React.ReactNode;
    lightIcon?: React.ReactNode;
    title: string;
  }[];
  isDashBoard?: boolean;
  isHomePage?: boolean;
}) => {
  const dashBoardBg = isHomePage ? "bg-[linear-gradient(180deg,rgba(45,43,46,0.54)_0%,rgba(51,47,70,0.54)_100%)]" : "bg-[linear-gradient(180deg,#F6F7F9_0%,#F8F8FB_100%)]";
  const nonDashBoardBg = isHomePage ? "hover:bg-[linear-gradient(274deg,#3C3945_4.08%,#262332_99.47%)]" : "hover:bg-[#F4F5F9]";
  const tilteTextColor = isHomePage ? "text-white" : "text-[#000]";
  const subItemBg = isHomePage ? "hover:bg-[#3C3945]" : "hover:bg-[#EBEDF3]";
  const subItemTextColor = isHomePage ? "text-[#8C9296]" : "text-[#6F7E8B]";
  const subItemHoverTextColor = isHomePage ? "hover:text-[#E8E8E8]" : "hover:text-[#262B2F]";
  const setOpenTitle = openTitleStore(state => state.setOpenTitle);
  return <div className={cx("flex min-h-[188px] min-w-[116px] flex-col gap-2 rounded-md pb-2", isDashBoard && dashBoardBg)} onClick={() => {
    setOpenTitle(null);
  }} data-sentry-component="CommonItem" data-sentry-source-file="CustomCreativity.tsx">
      <Link href={href} data-sentry-element="Link" data-sentry-source-file="CustomCreativity.tsx">
        <div className={cx("flex w-[140px] items-center justify-between gap-2 rounded-sm p-2", !isDashBoard && nonDashBoardBg)}>
          <div className="flex items-center gap-2">
            {isHomePage ? icon : lightIcon}
            <div className={cx("text-sm", tilteTextColor)}>{title}</div>
          </div>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="CustomCreativity.tsx">
            <path d="M3.85425 1.87506L6.97925 5.00006L3.85425 8.12506" stroke={isHomePage ? "white" : "#000"} strokeOpacity="0.4" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CustomCreativity.tsx" />
          </svg>
        </div>
      </Link>
      <div className="flex flex-col gap-1.5 px-2">
        {subItems.map(subItem => <Link href={subItem.href} key={subItem.href}>
            <div className={cx("flex items-center gap-1.5 rounded-sm p-1.5", isDashBoard && subItemBg)}>
              {isHomePage ? subItem?.icon : subItem?.lightIcon}
              <span className={cx("text-sm", subItemTextColor, !isDashBoard && subItemHoverTextColor)}>
                {subItem.title}
              </span>
            </div>
          </Link>)}
      </div>
    </div>;
};
export default function CreativityNavigation({
  isHomePage = false
}: {
  isHomePage?: boolean;
}) {
  return <div className="ml-20 flex gap-8" data-sentry-component="CreativityNavigation" data-sentry-source-file="CustomCreativity.tsx">
      <Link href="/aiToolV2/dashboard" data-sentry-element="Link" data-sentry-source-file="CustomCreativity.tsx">
        <div className={cx("flex w-[174px] gap-2 rounded-md p-2 pb-4", isHomePage ? "bg-[#2F2C3A]" : "bg-[#F7F8FA]")}>
          {isHomePage ? <CreativityDashboardIcon /> : <LightCreativityDashboardIcon />}
          <div className={cx("flex flex-col gap-[10px] rounded-sm pt-0.5")}>
            <span className={cx("text-sm", isHomePage && "text-white")}>
              工作台
            </span>
            <span className={cx("whitespace-pre-line text-xs", isHomePage ? "text-[#86909C]" : "text-[#8C9296]")}>
              {`最新类目爆款素材\n每日创作从这里开始`}
            </span>
          </div>
        </div>
      </Link>
      {creativityWorkshopList.map(item => <CommonItem key={item.title} {...item} isHomePage={isHomePage} />)}
    </div>;
}